/**
 * Function that returns default values.
 * Used because Object.assign does a shallow instead of a deep copy.
 * Using [].push will add to the base array, so a require will alter
 * the base array output.
 */
"use strict";

const path = require("path");
const srcPath = path.join(__dirname, "/../src");
const dfltPort = 8000;

// const BASE_URL_BACK = 'http://localhost:3000';
const BASE_URL_BACK = "https://medcafe2025-lurwq.ondigitalocean.app";

const proxy = {
  "/system/*": {
    target: BASE_URL_BACK,
    secure: false,
    changeOrigin: true,
  },
  "/images/*": {
    target: BASE_URL_BACK,
    secure: false,
    changeOrigin: true,
  },
  "/api/*": {
    target: BASE_URL_BACK,
    secure: false,
    changeOrigin: true,
  },
};

/**
 * Get the default modules object for webpack
 * @return {Object}
 */
function getDefaultModules() {
  return {
    preLoaders: [
      {
        test: /\.(js|jsx)$/,
        include: srcPath,
        loader: "eslint-loader",
      },
    ],
    loaders: [
      {
        test: /\.css$/,
        loader: "style-loader!css-loader",
      },
      {
        test: /\.sass/,
        loader:
          "style-loader!css-loader!sass-loader?outputStyle=expanded&indentedSyntax",
      },
      {
        test: /\.scss/,
        loader: "style-loader!css-loader!sass-loader?outputStyle=expanded",
      },
      {
        test: /\.less/,
        loader: "style-loader!css-loader!less-loader",
      },
      {
        test: /\.styl/,
        loader: "style-loader!css-loader!stylus-loader",
      },
      {
        test: /\.(png|jpg|jpeg|gif|svg|ico)$/,
        loader: "file-loader?name=assets/img/[name].[ext]",
      },
      {
        test: /\.(woff|woff2|eot|ttf)$/,
        loader: "file-loader?name=assets/fonts/[name].[ext]",
      },
      {
        test: /\.(mp4|ogg)$/,
        loader: "file-loader?name=assets/video/[name].[ext]",
      },
      {
        test: /\.(pdf)$/,
        loader: "file-loader?name=assets/[name].[ext]",
      },
    ],
  };
}

module.exports = {
  srcPath: srcPath,
  publicPath: "/assets/",
  port: dfltPort,
  getDefaultModules: getDefaultModules,
  proxy: proxy,
  BASE_URL_BACK: BASE_URL_BACK,
};



//////////////////
// WEBPACK FOOTER
// ./cfg/defaults.js
// module id = 1109
// module chunks = 0